import React from "react";
import { SvgIconProps } from "./SvgIconProps";

const SelectArrow: React.FC<SvgIconProps> = ({ color, ...props }) => (
    <svg viewBox="-20 -140 200 600" {...props}>
        <path d="M125.1562 139.2188 L73.125 191.25 L21.0938 139.2188 L125.1562 139.2188 Z" fill={color || "currentColor"} />
    </svg>
);

export default SelectArrow;